export default __webpack_public_path__ + "fc65bd36869ef6edd47bf26a4bb6c56f.svg";